/* ── Luxire Wishlist (via LuxireStorage) ── */
(function(){

  // Normalize a wishlist item — handles raw strings, objects with various field names
  function normalizeItem(item) {
    if (typeof item === 'string' && item.length > 0) {
      return { handle: item, title: '', image: '', price: '', url: '/products/' + item, variantId: null };
    }
    if (!item || typeof item !== 'object') return null;
    var handle = item.handle || item.product_handle || item.productHandle || '';
    if (!handle && (item.url || item.product_url)) {
      var m = (item.url || item.product_url || '').match(/\/products\/([^?#\/]+)/);
      if (m) handle = m[1];
    }
    return {
      handle: handle,
      title: item.title || item.product_title || '',
      image: item.image || item.featured_image || item.product_image || '',
      price: item.price || item.product_price || '',
      url: item.url || item.product_url || (handle ? '/products/' + handle : '#'),
      variantId: item.variantId || item.variant_id || null
    };
  }

  function getWishlist() {
    var raw = (typeof LuxireStorage !== 'undefined') ? LuxireStorage.getWishlistSync() : [];
    if (!Array.isArray(raw)) raw = [];
    return raw.map(normalizeItem).filter(Boolean);
  }

  function saveWishlist(list) {
    if (typeof LuxireStorage !== 'undefined') {
      LuxireStorage.saveWishlistSync(list);
    }
  }

  function isInWishlist(handle) {
    return (typeof LuxireStorage !== 'undefined') ? LuxireStorage.isWishlisted(handle) : false;
  }

  function addToWishlist(handle, title, image, price, url) {
    var list = getWishlist();
    if (!list.some(function(i){ return i.handle === handle; })) {
      var item = { handle: handle, title: title, image: image, price: price, url: url, added: Date.now() };
      list.push(item);
      saveWishlist(list);
      // Also fire async server sync for logged-in users
      if (typeof LuxireStorage !== 'undefined') {
        LuxireStorage.addToWishlist(item).catch(function(){});
      }
    }
    updateAllButtons();
    updateCount();
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function(i){ return i.handle !== handle; });
    saveWishlist(list);
    // Also fire async server sync for logged-in users
    if (typeof LuxireStorage !== 'undefined') {
      LuxireStorage.removeFromWishlist(handle).catch(function(){});
    }
    updateAllButtons();
    updateCount();
  }

  function toggleWishlist(handle, title, image, price, url) {
    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
    } else {
      addToWishlist(handle, title, image, price, url);
    }
  }

  /* Update all heart buttons on page */
  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn){
      var handle = btn.getAttribute('data-wishlist-handle');
      if (isInWishlist(handle)) {
        btn.classList.add('is-wishlisted');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('is-wishlisted');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  /* Update header wishlist count badge */
  function updateCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  // Enrich items missing product data directly from Shopify (no API proxy needed)
  // Enrich items missing product data directly from Shopify
  function enrichItems(items) {
    var needsEnrich = items.filter(function(item) {
      return item.handle && (!item.title || !item.image);
    });
    if (needsEnrich.length === 0) return Promise.resolve(items);

    return Promise.all(needsEnrich.map(function(item) {
      return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(product) {
          if (!product) return;
          if (!item.title) item.title = product.title || '';
          if (!item.image) item.image = product.featured_image || (product.images && product.images[0]) || '';
          if (!item.url || item.url === '#') item.url = '/products/' + item.handle;
          if (!item.price) {
            var p = product.price || (product.variants && product.variants[0] && product.variants[0].price);
            if (p) item.price = '$' + (parseFloat(p) / 100).toFixed(2);
          }
          if (!item.variantId && product.variants && product.variants[0]) {
            item.variantId = product.variants[0].id;
          }
        })
        .catch(function() {});
    })).then(function() {
      saveWishlist(items);
      return items;
    });
  }

  /* Render wishlist page grid — single render, no flashing */
  function renderWishlistPage() {
    var container = document.getElementById('wishlist-grid');
    if (!container) return;

    var list = getWishlist();
    var empty = document.getElementById('wishlist-empty');
    var countEl = document.getElementById('wishlist-total');

    if (list.length === 0) {
      container.innerHTML = '';
      if (empty) empty.style.display = '';
      if (countEl) countEl.textContent = '0';
      return;
    }

    if (empty) empty.style.display = 'none';
    if (countEl) countEl.textContent = list.length;

    // Check if cache already has full data (enriched from prior visit)
    var alreadyEnriched = list.every(function(item) { return item.title && item.image; });

    if (alreadyEnriched) {
      // Instant render — no flash
      renderWishlistCards(list, container);
    } else {
      // Show skeleton, enrich, then render ONCE
      container.innerHTML = list.map(function() {
        return '<div class="wishlist-card" style="opacity:0.5"><div class="wishlist-card__img-wrap" style="background:#f0eeeb;display:flex;align-items:center;justify-content:center;color:#999;font-size:13px;">Loading…</div><div class="wishlist-card__info"><div style="height:16px;width:60%;background:#f0eeeb;border-radius:4px;margin-bottom:8px;"></div></div></div>';
      }).join('');

      enrichItems(list).then(function(enriched) {
        renderWishlistCards(enriched, container);
      });
    }

    // Background: server refresh for cross-device sync (only re-renders if different items)
    if (typeof LuxireStorage !== 'undefined' && LuxireStorage.refreshWishlist) {
      LuxireStorage.refreshWishlist().then(function(serverItems) {
        if (!serverItems || !serverItems.length) return;
        var normalized = serverItems.map(normalizeItem).filter(Boolean);

        var cachedHandles = list.map(function(i) { return i.handle; }).sort().join(',');
        var serverHandles = normalized.map(function(i) { return i.handle; }).sort().join(',');
        if (cachedHandles === serverHandles) return;

        if (countEl) countEl.textContent = normalized.length;
        enrichItems(normalized).then(function(enriched) {
          renderWishlistCards(enriched, container);
        });
      }).catch(function() {});
    }
  }

  function renderWishlistCards(list, container) {
    container.innerHTML = list.map(function(item){
      var title = item.title || item.handle || 'Loading…';
      var url = item.url || (item.handle ? '/products/' + item.handle : '#');
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + title.replace(/"/g,'&quot;') + '" loading="lazy">'
        : '<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#ccc;font-size:13px;">' + (item.handle ? 'Fetching image…' : 'No image') + '</div>';

      return '<div class="wishlist-card">' +
        '<a href="' + url + '" class="wishlist-card__link">' +
          '<div class="wishlist-card__img-wrap">' + imgHtml + '</div>' +
          '<div class="wishlist-card__info">' +
            '<h3 class="wishlist-card__title">' + title + '</h3>' +
            (item.price ? '<p class="wishlist-card__price">' + item.price + '</p>' : '') +
          '</div>' +
        '</a>' +
        '<button class="wishlist-card__remove" data-remove-handle="' + (item.handle || '') + '" aria-label="Remove from wishlist">✕</button>' +
      '</div>';
    }).join('');

    container.querySelectorAll('[data-remove-handle]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        removeFromWishlist(btn.getAttribute('data-remove-handle'));
        renderWishlistPage();
      });
    });
  }

  /* Init */
  document.addEventListener('DOMContentLoaded', function(){
    /* Heart button clicks */
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(
        btn.getAttribute('data-wishlist-handle'),
        btn.getAttribute('data-wishlist-title'),
        btn.getAttribute('data-wishlist-image'),
        btn.getAttribute('data-wishlist-price'),
        btn.getAttribute('data-wishlist-url')
      );
    });

    updateAllButtons();
    updateCount();
    renderWishlistPage();
  });

  /* Expose for external use */
  window.LuxireWishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    isIn: isInWishlist
  };
})();
